import { render, staticRenderFns } from "./live-checked.vue?vue&type=template&id=31343f41&scoped=true&"
import script from "./live-checked.vue?vue&type=script&lang=js&"
export * from "./live-checked.vue?vue&type=script&lang=js&"
import style0 from "./live-checked.vue?vue&type=style&index=0&id=31343f41&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31343f41",
  null
  
)

export default component.exports